<template>
	<div
		v-editable="blok"
		class="relative flex h-full flex-col overflow-y-auto px-10 pt-14"
	>
		<div class="mb-4 flex justify-end">
			<button
				type="button"
				class="text-secondary-400 hover:text-secondary-500 absolute top-14 right-10 flex items-center gap-1 text-sm font-medium"
				@click="healthQuestionsModalOpen = true"
			>
				{{ t('paymentOptionsSlide.healthQuestions') }}
				<InformationCircleIcon class="size-4" />
			</button>
		</div>

		<PolicyBenefitsCards
			class="flex-1 items-center justify-center"
			:blok="blok"
		/>

		<HealthQuestionsModal
			v-model="healthQuestionsModalOpen"
			show-toggles
			:plans="plans"
		/>
	</div>
</template>

<script setup lang="ts">
import HealthQuestionsModal from '../merchandise/HealthQuestionsModal.vue'
import PolicyBenefitsCards from '../policyBenefits/policyBenefitsCards.vue'
import { usePresentationLocale } from '@/i18n'
import type { PolicyBenefitsSlideStoryblok } from '@/sbTypes'
import { useSessionStore } from '@/stores/session'
import { InformationCircleIcon } from '@heroicons/vue/24/solid'
import { computed, ref, type PropType } from 'vue'

const props = defineProps({
	blok: Object as PropType<PolicyBenefitsSlideStoryblok>,
})

const { t } = usePresentationLocale()

const sessionStore = useSessionStore()

const healthQuestionsModalOpen = ref(false)

const plans = computed(() => sessionStore.activePlans)
</script>
